<script>
	import { apiAuthorization } from '../js/model/stores';

	let deleteEnabeld = false;
	let supportersList;

	let authHeader;

	const apiList = 'https://api.wirunterstuetzenchemnitz.de/listSupporters';
	const apiDelete = 'https://api.wirunterstuetzenchemnitz.de/supporter/';

	apiAuthorization.subscribe(value => {
		authHeader = {
			'Authorization': value,
			'Content-Type': 'application/json'
		};
	});

	const fetchSupporters = (async () => {
		const response = await fetch(apiList, {
			headers: authHeader
		});
		return await response.json();
	})();

	async function deleteSupporter(id, event) {
		const response = await fetch(apiDelete + id, {
			headers: authHeader,
			method: 'DELETE',
		});
		Promise.resolve(response).then(() => {
			event.target.parentElement.parentElement.classList.add('deleted');
			setTimeout(() => {
				event.target.parentElement.parentElement.remove();
			}, 500);
		});
	}

	function convertDate(date) {
		const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
		const dateFormatted = new Date(date);
		return dateFormatted.toLocaleDateString("de-DE", options);
	}
</script>
<style>
	table {
		width: 100%;
		max-width: 1000px;
		margin: auto;
		border-spacing: 0;
	}

	tr {
		font-size: 15px;
		transition: background-color .5s;
	}

	tr:first-of-type {
		position: sticky;
		top: 0;
		background-color: var(--color-blue);
		z-index: 1;
	}

	:global(tr.deleted) {
		background-color: var(--color-light-magenta);
	}

	th {
		border-bottom: 3px solid var(--color-grey);
		margin: 0;
		padding: 10px 5px;
		text-align: left;
		font-size: 20px;
	}

	th.delete_header {
		width: 230px;
	}

	th input {
		margin: 0 0 0 10px;
	}

	td {
		border-bottom: 1px solid var(--color-light-grey);
		padding: 5px;
	}

	.delete {
		background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkzLjc4IiBoZWlnaHQ9IjQ2OC4zNiIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgMjkzLjc4IDQ2OC4zNiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04Ny4yODgpIiBmaWxsPSIjZmUwMDAwIj4NCgkJPHBhdGggZD0ibTM4MS4wNSA2NC4yMjktNzEuMzk2IDAuMDMxLTAuMDI4LTY0LjI2LTE1MC45NiAwLjA2NCAwLjAyNyA2NC4yNi03MS40MDUgMC4wMzEgMC4wMjQgNjAuMDU2aDI5My43NnptLTE5MS43Ny0zMy41NzcgODkuNzU5LTAuMDQgMC4wMTYgMzMuNjYtODkuNzU5IDAuMDR6Ii8+DQoJCTxwYXRoIGQ9Im04Ny4zMTIgNDY4LjM2aDI5My43NnYtMzI4LjY1aC0yOTMuNzZ6bTIxNS43My0yODMuNzdoMTUuMzAxdjIzOC44OWgtMTUuMzAxem0tNzYuNSAwaDE1LjN2MjM4Ljg5aC0xNS4zem0tNzYuNSAwaDE1LjN2MjM4Ljg5aC0xNS4zeiIvPg0KCTwvZz4NCjwvc3ZnPg0K');
		height: 30px;
		background-position: center;
		background-size: contain;
		background-repeat: no-repeat;
	}

	.delete--active {
		opacity: 1;
		cursor: pointer;
	}

	.delete--inactive {
		opacity: .4;
	}
</style>
<table>
	<tr>
		<th>eingetragen</th>
		<th>Name</th>
		<th>E-Mail</th>
		<th class="delete_header">Löschen aktivieren:<input type="checkbox" on:click={() => deleteEnabeld = !deleteEnabeld}></th>
	</tr>
	{#await fetchSupporters}
		<tr>
			<td colspan="4">
				<p>...Unterstützer werden geladen</p>
			</td>
		</tr>
	{:then supporters}
		{#each supporters as supporter, i}
			<tr>
				<td>
					{convertDate(supporter.added)}
				</td>
				<td>
					{@html supporter.name}
				</td>
				<td>
					{@html supporter.email}
				</td>
				<td>
					{#if deleteEnabeld}
						<div class="delete delete--active" on:click|once={(event) => deleteSupporter(supporter._id['$oid'], event)}></div>
					{:else}
						<div class="delete delete--inactive"></div>
					{/if}
				</td>
			</tr>
		{/each}
	{:catch error}
		<tr>
			<td colspan="4">
				<p>...Unterstützer konnten nicht geladen werden</p>
			</td>
		</tr>
	{/await}

</table>